export const isDevelopment = process.env.NODE_ENV === 'development'

export const isProd = process.env.REACT_APP_STAGE === 'prod'
